import React, { createContext, useContext, useState } from 'react';
import LoadingAnimation from '../ui/LoadingAnimation';

const LoadingContext = createContext();

export const LoadingStates = Object.freeze({
    SHOW: Symbol('loading'),
    SUCCESS: Symbol('success'),
    FAILURE: Symbol('failure'),
});

export const LoadingProvider = ({ children }) => {
    const [isLoading, setLoading] = useState(null);

    const showLoading = () => setLoading(LoadingStates.SHOW);

    const hideLoading = () => setLoading(null);

    const showLoadingSuccess = () => setLoading(LoadingStates.SUCCESS);

    const showLoadingError = () => setLoading(LoadingStates.FAILURE);

    return (
        <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading, showLoadingSuccess, showLoadingError }}>
            {isLoading !== null && <LoadingAnimation loading={isLoading} setLoading={setLoading} />}
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    return useContext(LoadingContext);
};
